import { observer } from 'mobx-react-lite';
import React, { Fragment } from 'react';
import {
  SingleValueConditionOperator,
  CONDITIONS_REQUIRING_VALUES,
} from '../../../../../../architecture/enums/Condition';
import { ContextCondition } from '../../../../../../models/Conditions/ContextCondition';
import Input from '../../../../../common/Input';
import TextBoxWithCtx from '../../../../../common/inputElements/TextBoxWithCtx';
import Select from '../../../../../common/inputElements/select/Select';

interface IProps {
  condition: ContextCondition;
}
const SingleValueContextVariableHandler: React.FC<IProps> = ({ condition }) => {
  const handleConditionSelection = (operator: string) => {
    condition.operator =
      SingleValueConditionOperator[operator as SingleValueConditionOperator];
  };

  const handleConditionValueChange = (value: string) => {
    condition.value = value;
  };

  return (
    <Fragment>
      <Select
        items={Object.values(SingleValueConditionOperator).map((operator) => ({
          title: operator,
        }))}
        selectHandler={handleConditionSelection}
        search
        closeOnSelect
        triggerLabel={condition.operator ?? 'Choose a condition'}
      />
      {/* Showing input field only if it is necessary */}
      {CONDITIONS_REQUIRING_VALUES.includes(condition.operator) && (
        <TextBoxWithCtx
          className="condition-setting-ctx"
          value={condition.value?.toString() ?? ''}
          saveHandler={handleConditionValueChange}
          placeholder=''
          multiline={false}
        />
      )}
    </Fragment>
  );
};

export default observer(SingleValueContextVariableHandler);
